var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "crumbs-totals" },
        [_vm._t("breadcrumbs"), _vm._v(" "), _vm._t("totals")],
        2
      ),
      _vm._v(" "),
      _vm._t("groupBy"),
      _vm._v(" "),
      _vm._t("pagination"),
      _vm._v(" "),
      _vm._t("annotation-switcher"),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c(
          "div",
          { staticClass: "btn-group", staticStyle: { margin: "auto" } },
          _vm._l(_vm.chartModeOptions, function (option) {
            return _c(
              "button",
              {
                key: option,
                class: [
                  "btn btn-default btn-sm",
                  { active: _vm.chartMode === option },
                ],
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    _vm.chartMode = option
                  },
                },
              },
              [_vm._v(_vm._s(option))]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c("GroupTable", {
        attrs: {
          type: _vm.type,
          headers: _vm.headers,
          columns: _vm.columns,
          data: _vm.rows,
          maxima: _vm.maxima,
          mainAnnotation: _vm.mainAnnotation,
          otherAnnotations: _vm.otherAnnotations,
          metadata: _vm.metadata,
          query: _vm.results.summary.searchParam,
          disabled: _vm.disabled,
          html: _vm.html,
          dir: _vm.dir,
        },
        on: {
          changeSort: _vm.changeSort,
          openFullConcordances: _vm.openFullConcordances,
        },
      }),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-right" },
        [_vm._t("sort"), _vm._v(" "), _vm._t("export")],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }